// app/javascript/text_to_path.js
// Браузерная векторизация текста через opentype.js.
// Зеркало lib/text_to_path.mjs: базовая линия y=0, левый край x=0.
// Отличие: шрифт грузится через fetch+arrayBuffer (нет Buffer/fs), срез buf.buffer не нужен.
import opentype from "opentype.js"
import { pathDataFrom } from "./path_data.js"

const fontCache = new Map()   // fileUrl → Promise<opentype.Font>

export function loadFont(fileUrl) {
  if (!fontCache.has(fileUrl)) {
    fontCache.set(fileUrl, fetch(fileUrl).then((r) => r.arrayBuffer()).then((b) => opentype.parse(b)))
  }
  return fontCache.get(fileUrl)
}

// Зеркало lib/text_to_path.mjs: базовая линия y=0, левый край x=0.
// Раскладка: x += advanceWidth*scale + letterSpacingPx; ширина = x - letterSpacingPx.
export function textToPath(font, text, fontSizePx, letterSpacingPx = 0) {
  if (!text) return { pathD: "", width: 0, baseline: 0 }
  const scale = fontSizePx / font.unitsPerEm
  // baseline: y-сдвиг базовой линии, чтобы визуальный центр текста встал на якорь (y=0)
  const baseline = ((font.ascender + font.descender) / 2) * scale
  let x = 0
  const full = new opentype.Path()
  for (const glyph of font.stringToGlyphs(text)) {
    full.extend(glyph.getPath(x, 0, fontSizePx))
    x += (glyph.advanceWidth || 0) * scale + letterSpacingPx
  }
  return { pathD: pathDataFrom(full.commands), width: x - letterSpacingPx, baseline }
}
